<p>data-insert works!</p>
<textarea #txtcommands cols="50" rows="10"></textarea>
<button
  type="button"
  (click)='DBActivity(txtcommands.value)'>
  Run Data
</button>
